import algolia from 'algoliasearch'

const appId = process.env.REACT_APP_ALGOLIA_APP_ID as string
const apiKey = process.env.REACT_APP_ALGOLIA_API_KEY as string

export const client = algolia(appId, apiKey)
export const userIndex = client.initIndex('prod_user')
